import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/components/View';
import TwoFactorAuthMethods from '../../constants/TwoFactorAuthMethods';
import TwoFactorAuthAppStates from '../../constants/TwoFactorAuthAppStates';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import CodeEntryForm from '../legacyLogins/two-factor-auth/CodeEntryForm';
import { TWO_FACTOR_KEY } from '../../constants/CodeEntryKeyWords';
import { TwoFactorAuthVerifyV4 } from './TwoFactorAuthVerifyV4';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TwoFactorAuthForm extends Component {
  constructor(...args) {
    super(...args);
    this.twoFactorMethodIs = expected => {
      return this.props.twoFactorMethod && this.props.twoFactorMethod.method === expected;
    };
    this.getCodeLength = () => {
      const {
        appState,
        totp
      } = this.props;
      if (appState === TwoFactorAuthAppStates.DEFAULT) {
        return 6;
      } else if (!totp) {
        return 20;
      }
      return 10 + (totp.split(' ').length - 1);
    };
    this.shouldRenderFooter = () => {
      const {
        hasSecondaryMethod,
        backupCodesEnabled
      } = this.props;
      return this.twoFactorMethodIs(TwoFactorAuthMethods.SMS) || backupCodesEnabled || hasSecondaryMethod;
    };
    this.renderSubmitButton = () => {
      const {
        isVerifying,
        isRequestingCode,
        totp
      } = this.props;
      if (isVerifying || isRequestingCode) {
        return /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          minHeight: "56px"
        });
      }
      return /*#__PURE__*/_jsx(View, {
        maxInlineSize: "350px",
        children: /*#__PURE__*/_jsx(Button, {
          block: true,
          use: "primary",
          type: "submit",
          disabled: !totp || totp.length < this.getCodeLength(),
          "data-test-id": "confirm-to-login-submit",
          children: I18n.text('login.twoFactor.loginButton')
        })
      });
    };
    this.renderIllustration = () => {
      return this.twoFactorMethodIs(TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR) ? /*#__PURE__*/_jsx(Illustration, {
        name: "mobile-notify",
        width: "100%"
      }) : /*#__PURE__*/_jsx(Illustration, {
        name: "keys",
        width: "100%"
      });
    };
  }
  render() {
    var _this$props$twoFactor;
    const {
      twoFactorMethod,
      isVerifying,
      isRequestingCode,
      onSubmit,
      onCodeChange,
      totp,
      toggleRememberDevice,
      appState,
      areBothGoogleAuth
    } = this.props;
    const lastFour = twoFactorMethod && twoFactorMethod.obfuscatedInfo ? twoFactorMethod.obfuscatedInfo.substr(twoFactorMethod.obfuscatedInfo.length - 4) : '';
    let description;
    if (appState === TwoFactorAuthAppStates.BACKUP) {
      description = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "login.twoFactor.backupCode.description"
      });
    } else if (this.twoFactorMethodIs(TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR)) {
      description = null;
    } else {
      description = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.twoFactor.description"
      });
    }
    let header;
    if (this.twoFactorMethodIs(TwoFactorAuthMethods.SMS)) {
      header = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "login.twoFactor.headerSms",
        options: {
          lastFour
        }
      });
    } else if (this.twoFactorMethodIs(TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR)) {
      header = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "login.twoFactor.headerHubspotApp",
        options: {
          lastFour
        }
      });
    } else if (areBothGoogleAuth) {
      header = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.twoFactor.googleAuth.bothGoogleAuthDescription"
      });
    } else {
      header = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.twoFactor.header"
      });
    }
    return this.props.isUngatedForLoginV4 ? /*#__PURE__*/_jsx(TwoFactorAuthVerifyV4, {
      appState: this.props.appState,
      areBothGoogleAuth: this.props.areBothGoogleAuth,
      backupCodesEnabled: this.props.backupCodesEnabled,
      callForCode: this.props.callForCode,
      codeLength: this.getCodeLength(),
      code: totp || '',
      hasSecondaryMethod: this.props.hasSecondaryMethod,
      isRequestingCode: isRequestingCode,
      isVerifying: isVerifying,
      lastFour: lastFour,
      onCodeChange: onCodeChange,
      onLostDevice: this.props.onLostDevice,
      onRestartTimer: this.props.onRestartTimer,
      onSubmit: onSubmit,
      retryCode: this.props.retryCode,
      switchAppState: this.props.switchAppState,
      switchVerificationMethod: this.props.switchVerificationMethod,
      twoFactorAuthMethod: (_this$props$twoFactor = this.props.twoFactorMethod) === null || _this$props$twoFactor === void 0 ? void 0 : _this$props$twoFactor.method
    }) : /*#__PURE__*/_jsx(CodeEntryForm, {
      keyWord: TWO_FACTOR_KEY,
      header: header,
      description: description,
      onSubmit: onSubmit,
      onCodeChange: onCodeChange,
      codeLength: this.getCodeLength(),
      shouldRenderFooter: this.shouldRenderFooter(),
      inputValue: totp,
      isVerifying: isVerifying,
      isRequestingCode: isRequestingCode,
      toggleRememberDevice: toggleRememberDevice,
      renderSubmitButton: this.renderSubmitButton,
      renderIllustration: this.renderIllustration,
      appState: this.props.appState,
      areBothGoogleAuth: this.props.areBothGoogleAuth,
      switchVerificationMethod: this.props.switchVerificationMethod,
      hasSecondaryMethod: this.props.hasSecondaryMethod,
      twoFactorLevel: this.props.twoFactorLevel,
      switchAppState: this.props.switchAppState,
      backupCodesEnabled: this.props.backupCodesEnabled,
      onLostDevice: this.props.onLostDevice,
      onReturnToLogin: this.props.onReturnToLogin,
      isSms: this.twoFactorMethodIs(TwoFactorAuthMethods.SMS),
      retryCode: this.props.retryCode,
      callForCode: this.props.callForCode,
      isHubspotAuthenticator: this.twoFactorMethodIs(TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR),
      onRestartTimer: this.props.onRestartTimer
    });
  }
}
TwoFactorAuthForm.propTypes = {
  totp: PropTypes.string,
  twoFactorMethod: PropTypes.object,
  hasSecondaryMethod: PropTypes.bool.isRequired,
  isVerifying: PropTypes.bool.isRequired,
  isRequestingCode: PropTypes.bool.isRequired,
  onCodeChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onLostDevice: PropTypes.func.isRequired,
  switchVerificationMethod: PropTypes.func.isRequired,
  retryCode: PropTypes.func.isRequired,
  callForCode: PropTypes.func.isRequired,
  toggleRememberDevice: PropTypes.func.isRequired,
  twoFactorLevel: PropTypes.string.isRequired,
  backupCodesEnabled: PropTypes.bool.isRequired,
  appState: PropTypes.string.isRequired,
  switchAppState: PropTypes.func.isRequired,
  areBothGoogleAuth: PropTypes.bool.isRequired,
  onReturnToLogin: PropTypes.func.isRequired,
  onRestartTimer: PropTypes.func.isRequired
};